import type { ViewsService } from '../../Views.service';
import type { ViewEntity } from '../../models/viewEntity/view.entity.ts';
import { REPORT_VIEW_DESCRIPTOR } from './constants';

export class ViewSwitcher {
  private _currentViewDescriptor?: string;

  private _tempView?: ViewEntity;

  private _viewsService: ViewsService;

  public constructor(viewsService: ViewsService) {
    this._viewsService = viewsService;
  }

  public init(): void {
    this._currentViewDescriptor = undefined;
  }

  public switchView(descriptor: string): void {
    if (this._currentViewDescriptor === descriptor) {
      return;
    }
    const sourceView = this._viewsService.getViewByDescriptor(descriptor);
    if (!sourceView) {
      throw new Error('No view found for descriptor ' + descriptor);
    }
    if (this._tempView) {
      this._viewsService.removeView(this._tempView);
    }
    this._tempView = sourceView.clone();
    this._tempView.setDescriptor(REPORT_VIEW_DESCRIPTOR);
    this._viewsService.addView(this._tempView);
    this._viewsService.setCurrentView(this._tempView);
    this._currentViewDescriptor = descriptor;
  }
}
